import React from 'react';
import { Mail, Phone } from 'lucide-react';
import type { ContactInfo } from '../../utils/contactInfoDetection';

interface ContactInfoBadgeProps {
  info: ContactInfo;
}

export function ContactInfoBadge({ info }: ContactInfoBadgeProps) {
  const Icon = info.type === 'email' ? Mail : Phone;
  
  return (
    <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs bg-gradient-to-r from-blue-600/40 to-teal-500/40 text-white font-medium border border-blue-500/20 shadow-sm">
      <Icon className="w-3 h-3 flex-shrink-0" />
      <span className="truncate max-w-[120px] md:max-w-[200px]">{info.value}</span>
    </div>
  );
}